export function PreventDefault() {
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        descriptor.value = function () {
            if (arguments.length && arguments[0].preventDefault)
                arguments[0].preventDefault();
            return method.apply(this, Array.prototype.slice.call(arguments));
        };
    };
}
//# sourceMappingURL=PreventDefault.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/decorators/PreventDefault.js
// module id = 43
// module chunks = 1